import { SearchOutlined } from "@ant-design/icons";
import { Button, Form, Input, Row, Space, Tag } from "antd";
import "moment/locale/zh-cn";
import React, { ReactElement, useState } from "react";
import { SupervisorSelectModal } from "../../components/modal/SupervisorSelectModal";
import { OrganizationParams } from "../../services/organizationMessage";

export const OrganizationMessageQuerys = (props: {
  onValueChange: (queries: OrganizationParams) => void;
}): ReactElement => {
  const [form] = Form.useForm();

  const [isModalVisible, setModalVisible] = useState(false);

  const [selectedSupervisors, setSelectedSupervisors] = useState<any[]>([]);

  return (
    <>
      <Form form={form} onFinish={(values) => props.onValueChange(values)}>
        <Row
          style={{ marginBottom: 10, width: '100%' }}
          align='middle'
          justify='space-between'
        >
          <Space>
            <Button type='primary' onClick={() => setModalVisible(true)}>
              选择卫健委(局)
            </Button>
            {/* <Form.Item name="orgProperty" noStyle>
              <Select
                placeholder="机构属性"
                allowClear
                suffixIcon={<CaretDownFilled />}
                style={{ width: 100 }}
                onChange={form.submit}
              >
                <Option value={0}>民营</Option>
                <Option value={1}>公立</Option>
              </Select>
            </Form.Item> */}
            <Form.Item name='osIds' noStyle>
              <Input type='hidden' />
            </Form.Item>
          </Space>
          <Space>
            <Form.Item name='orgNameOrCode' noStyle>
              <Input
                autoComplete='off'
                placeholder='机构名称/机构编码'
                style={{ width: 250 }}
                prefix={<SearchOutlined />}
                allowClear
                onChange={form.submit}
              />
            </Form.Item>
            <Button type='primary' onClick={form.submit}>
              查询
            </Button>
          </Space>
        </Row>
        <Row style={{ marginTop: 10 }} align='middle'>
          {selectedSupervisors.map((s) => (
            <Tag
              key={s.osId}
              closable
              onClose={() => {
                const selected = selectedSupervisors.filter(
                  (ss) => ss.osId !== s.osId
                )
                setSelectedSupervisors(selected)
                form.setFieldsValue({
                  osIds:
                    selected.length === 0
                      ? undefined
                      : selected.map((s) => s.osId).join(','),
                })
                form.submit()
              }}
            >
              {s.osName}
            </Tag>
          ))}
        </Row>
      </Form>
      <SupervisorSelectModal
        visible={isModalVisible}
        initialValue={selectedSupervisors}
        onCancel={() => setModalVisible(false)}
        onOk={() => setModalVisible(false)}
        onChange={(s) => {
          const selected = s || []
          setSelectedSupervisors(selected)
          form.setFieldsValue({
            osIds:
              selected.length === 0
                ? undefined
                : selected.map((s) => s.osId).join(','),
          })
          form.submit()
        }}
      />
    </>
  )
};
